var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:['z-badge', {'z-badge__dot': _vm.dot}]},[_vm._t("default"),_c('div',{staticClass:"z-badge__wrapper"},[_c('div',{staticClass:"z-badge__badge"},[_vm._v(_vm._s(_vm.displayContent))])])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }